import React from 'react';

const TwitterLink = props =>
  <a
    rel="noopener"
    target="_blank"
    href="https://twitter.com/depop/"
    {...props}>
    Twitter
  </a>;

export default TwitterLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/TwitterLink.js